import type { Event } from "../../../../api/useEvents";
import t from "../../../../i18n";
import { toPath } from "../../../../router/helpers/path";
import type { PriorityFaultEvent } from "diagnostics-domain/faultEvent";
import { colors } from "@ui/Theme";
import {
  CLASSIC_FAILURE,
  FAULT_IMPACT_SERIE,
  MANUAL_FAILURE,
  MANUAL_FAILURE_IMPACT_SERIE,
  QUANTITY_UNEXPLAINED_GAP_ID,
  UNEXPLAINED_GAP_ID,
} from "../../Chart/series/serieIds";

export const createManualFaultEventDrawerParamURL = "create-manual-fault-event";

export const gotoEventsPage = (event: Event) =>
  toPath("/projects/:projectId/fault-events", {
    projectId: event.projectId,
  });
export const gotoEventPage = (event: Event) => {
  switch (event.type) {
    case "DIAGNOSED":
      return toPath("/projects/:projectId/fault-events/:faultEventId/fault", {
        projectId: event.projectId,
        faultEventId: event.id,
      });
      break;
    case "MANUAL":
      return toPath("/projects/:projectId/fault-events/manual/:manualFaultEventId/fault", {
        projectId: event.projectId,
        manualFaultEventId: event.id,
      });
      break;
    default: {
      const n: never = event;
      throw n;
    }
  }
};

export const getEventPriorityText = (priority: PriorityFaultEvent) => {
  switch (priority) {
    case "HIGH":
      return t("project.fault_event.priority.high");
    case "MEDIUM":
      return t("project.fault_event.priority.medium");
    case "LOW":
      return t("project.fault_event.priority.low");
    default:
      throw new Error(priority satisfies never);
  }
};

export const EVENT_PRIORITIES: PriorityFaultEvent[] = ["HIGH", "MEDIUM", "LOW"];

export const getEventPriorityColor = (priority: PriorityFaultEvent) => {
  switch (priority) {
    case "HIGH":
      return {
        textColor: colors.hydrogen,
        backgroundColor: colors.oxygen600,
      };
    case "MEDIUM":
      return {
        textColor: colors.hydrogen,
        backgroundColor: colors.oxygen400,
      };
    case "LOW":
      return {
        textColor: colors.oxygen800,
        backgroundColor: colors.oxygen50,
      };
    default:
      throw new Error(priority satisfies never);
  }
};

export const getEventpriorityOrder = (priority: PriorityFaultEvent) => {
  switch (priority) {
    case "HIGH":
      return 0;
    case "MEDIUM":
      return 1;
    case "LOW":
      return 2;
    default:
      throw new Error(priority satisfies never);
  }
};

export const getEventVisibleSeries = (event: Event) => {
  const excludeSerieIds = [UNEXPLAINED_GAP_ID, QUANTITY_UNEXPLAINED_GAP_ID];

  switch (event.type) {
    case "DIAGNOSED":
      return {
        included: [CLASSIC_FAILURE],
        excluded: [...excludeSerieIds, MANUAL_FAILURE],
      };
    case "MANUAL":
      return {
        included: [MANUAL_FAILURE],
        excluded: [...excludeSerieIds, CLASSIC_FAILURE],
      };
    default: {
      const n: never = event;
      throw n;
    }
  }
};

export const getEventVisibleImpactSeries = (event: Event) => {
  const excludeSerieIds = [UNEXPLAINED_GAP_ID, QUANTITY_UNEXPLAINED_GAP_ID];

  switch (event.type) {
    case "DIAGNOSED":
      return {
        included: [FAULT_IMPACT_SERIE],
        excluded: [...excludeSerieIds, MANUAL_FAILURE_IMPACT_SERIE],
      };
    case "MANUAL":
      return {
        included: [MANUAL_FAILURE_IMPACT_SERIE],
        excluded: [...excludeSerieIds, FAULT_IMPACT_SERIE],
      };
    default: {
      const n: never = event;
      throw n;
    }
  }
};
